export const TodoistIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 1000 1000"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="1000" height="1000" rx="120" fill="#E44332" />
    <path
      d="M-32 292 190 431 567 222M-32 461 190 600 567 391M-32 630 190 769 567 560"
      stroke="#fff"
      strokeWidth="74"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
